// extracted by mini-css-extract-plugin
module.exports =  {"sheet":"sheet-tOWsB"};